import Header from "./Header/Header";
import Main from "./Main/Main";
import ChildThemeWarningNotice from "./ChildThemeWarningNotice";
import { useEffect } from "react";

export default function App() {

  const displayChildThemeWarning = responsive_addons_site_builder.childThemeDetected && ! responsive_addons_site_builder.isChildThemeWarningDismissed;

  useEffect(()=>{
    const wpToolBar = document.querySelector('html.wp-toolbar');
    if(wpToolBar){
      wpToolBar.style.paddingTop = 0;
    }
  },[]);

  return (
    <div className="flex flex-col h-screen">
      <Header />
      <Main />
      { displayChildThemeWarning && <ChildThemeWarningNotice /> }
    </div>
  );
}